"use strict";

module.exports = function extend(target, source) {
    var ret = {};
    var key = void 0;
    for (key in target) {
        ret[key] = target[key];
    }
    for (key in source) {
        if (source.hasOwnProperty(key) && source[key] !== undefined) {
            ret[key] = source[key];
        }
    }
    return ret;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/extend.js
// module id = 62
// module chunks = 0